import { SectionHeader } from "../../components/public/ui";

const steps = [
  {
    n: "01",
    badge: "bg-primary-fixed text-primary",
    title: "Create Your Free Account",
    body: "Sign up in 30 seconds and take an initial diagnostic test to discover your current Canadian Language Benchmark (CLB) score.",
  },
  {
    n: "02",
    badge: "bg-secondary-fixed text-secondary",
    title: "Choose Your Practice Focus",
    body: "Select the specific test strand you need — Listening, Reading, Writing, or Speaking — or take a complete timed mock exam.",
  },
  {
    n: "03",
    badge: "bg-tertiary-fixed text-tertiary",
    title: "Practice & Improve",
    body: "Complete exercises, receive instant automated analysis, and review step-by-step model answers to consistently push your score higher.",
  },
];

export const HowItWorks = () => (
  <section
    className="w-full py-20 bg-surface-container-low/40 scroll-mt-20"
    id="how-it-works"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <SectionHeader
        eyebrow="Effortless Workflow"
        title="Start Preparing in Three Simple Steps"
        description="From first login to exam mastery, we provide an uncluttered path to your required band score."
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
        {steps.map((s) => (
          <div
            key={s.n}
            className="bg-surface-container-lowest p-8 rounded-2xl shadow-sm flex flex-col gap-4 relative"
          >
            <div
              className={`w-12 h-12 rounded-xl flex items-center justify-center font-headline-sm text-headline-sm font-extrabold ${s.badge}`}
            >
              {s.n}
            </div>
            <h3 className="font-headline-sm text-headline-sm text-on-surface font-bold">
              {s.title}
            </h3>
            <p className="font-body-md text-body-md text-on-surface-variant leading-relaxed">
              {s.body}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
